
function headers() {
    const token = localStorage.getItem('token')
    return token ? {
        'x-access-token': JSON.parse(token),
    } : {};
}

function roles(): string[] {
    try {
        const stored = localStorage.getItem('roles');
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function isAdmin(): boolean {
    return roles().includes('admin');
}

const Auth = {
    headers,
    roles,
    isAdmin,
};

export default Auth;
